export default __webpack_public_path__ + "static/media/recruit01.f7409f75.jpg";